const moduleName = 'service-desk';

export default {
  SET_CALLED_RESULT: `@${moduleName}/SET_CALLED_RESULT`,
  SET_CALLED_FILTER: `@${moduleName}/SET_CALLED_FILTER`,
  CLEAR_CALLED_FILTER: `@${moduleName}/CLEAR_CALLED_FILTER`,

  SET_DASHBOARD_DATA: `@${moduleName}/SET_DASHBOARD_DATA`
};
